export default "__VITE_ASSET__ABKycENM__"